import './ProjectCard.scss'

import React from 'react'
import {useTranslation} from '../../../util/i18n'
import {style} from '../../../util/style'
import {Icon} from '../../../views/ui/Icon'
import {Theme} from '../../Theme'
import {
	Card,
	CardContent,
	CardImage,
	CardImageOverlay,
	CardLink,
	CardText,
	CardTitle,
	CardType
} from '../../ui/Card'
import {ThemeIconType} from '../worldmap/ThemeIcon'

const styles = style('projectcard', ['image'])

export type ProjectCardType = CardType & {
	subtitle?: string
	icon?: ThemeIconType
}

export const ProjectCard: React.FC<ProjectCardType> = ({
	url,
	image,
	icon,
	title,
	subtitle,
	text
}) => {
	const t = useTranslation('cards').project

	return (
		<Card layout="project" className={styles()}>
			<CardImage image={image} url={url}>
				<CardImageOverlay />
				{icon && (
					<span className={styles.image('icon')}>
						<Icon icon={icon} />
					</span>
				)}
			</CardImage>
			<CardContent>
				<CardTitle
					theme={Theme.H5}
					as="h3"
					mod="bold"
					title={title}
					url={url}
				/>
				{subtitle && (
					<Theme.H5 className={styles('subtitle')} mod={['bold', 'green']}>
						{subtitle}
					</Theme.H5>
				)}
				<CardText text={text} />
				<CardLink url={url} description={t.linklabel} />
			</CardContent>
		</Card>
	)
}
